module.exports = "https://static.wagwalking.com/_next/static/images/happy-dog-3-42ed34b1428c15396f60983a329030ea.svg";